import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./AgriFreshHow.module.scss";

import BagFull from "../../assets/jpg/BagFull.jpg";

export default class AgriFreshHow extends Component {
  render() {
    return (
      <section id={styles.AgriFreshHow}>
        <Container id="HowAgriFreshWorks" fluid>
          <Row>
            <Col lg={7} id={styles.Box1}>
              <div className={styles.vl}></div>
              <p id={styles.Header}>
                How <br></br>AgriFresh<sup>TM</sup>
                <br></br> Works
              </p>
              <br></br>
              <p id={styles.SubHeader}>
                SPOILED PRODUCE NO MORE<sup>TM</sup>
              </p>
              <br></br>

              <p className={styles.content}>
                <b>
                  <i>
                    Of the 2.2 million tonnes of edible food wasted each year in
                    Canada (1.3 billion tonnes globally), 30% is vegetables and
                    15% is fruit.
                  </i>
                </b>
              </p>
              <br></br>
              <p className={styles.content}>
                <b>
                  AgriFresh naturally extends the shelf life of fruits and
                  vegetables by up to 5x.
                </b>{" "}
                By absorbing greenhouse gases that cause bacteria to grow on
                fruits and vegetables, AgriFresh significantly delays the
                microbial spoilage and ripening process of produce.
              </p>
              <br></br>
              <p className={styles.content}>
                From factory to store, AgriFresh can be sprayed or misted
                directly on produce or produce bedding, placed in boxes during
                shipping and/or importing/exporting, or placed in packaged
                produce that lie on grocery store shelves. Best methods vary
                from fruit to fruit and vegetable to vegetable.
              </p>
              <br></br>
              <p className={styles.content}>
                <b>
                  <i>100% natural.</i>
                </b>
              </p>
              {/* <br></br>
              <p id={styles.SmallText}>
                *Approved for use in foods under the Food and Drug Regulations
                [Section B.16.100].
              </p> */}
            </Col>

            <Col lg={5} id={styles.Box2}>
              <Image
                src={BagFull}
                width={1600}
                height={1600}
                id={styles.BagFull}
              />
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
